import React, { FC } from 'react';

interface TotalSectionProps {
  total: string;
  dueDate: string;
  date: string;
  isEstimate?: boolean;
  expiryDate?: string;
  updatedAt?: string;
}

const TotalSection: FC<TotalSectionProps> = ({ total, dueDate, date, isEstimate = false, expiryDate, updatedAt }) => (
  <div className="flex flex-col gap-2 rounded-md border border-borderGray bg-white p-10">
    <div className="flex items-center">
      <div className="text-[40px] font-bold text-headingGray">{`$${total}`}</div>
    </div>
    {isEstimate ? (
      <>
        <div className="flex gap-x-2.5">
          <div className="text-sbase font-semibold text-accentText">Date issued</div>
          <div className="text-sbase font-semibold text-primaryText">{date}</div>
        </div>
        {expiryDate && (
          <div className="flex gap-x-2.5">
            <div className="text-sbase font-semibold text-accentText">Expires on</div>
            <div className="text-sbase font-semibold text-primaryText">{expiryDate}</div>
          </div>
        )}
        {updatedAt && (
          <div className="flex gap-x-2.5">
            <div className="text-sbase font-semibold text-accentText">Last updated on</div>
            <div className="text-sbase font-semibold text-primaryText">{updatedAt}</div>
          </div>
        )}
      </>
    ) : (
      <>
        {dueDate && (
          <div
            className="w-fit rounded-md border border-transparent bg-secondaryBtn px-2.5
        py-[5px] text-sbase font-semibold text-secondary">
            {`Balance due by ${dueDate}`}
          </div>
        )}
        <div className="flex gap-x-2.5">
          <div className="text-sbase font-semibold text-accentText">Invoice date</div>
          <div className="text-sbase font-semibold text-primaryText">{date}</div>
        </div>
      </>
    )}
  </div>
);

export default TotalSection;
